import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0B7894",
      },
      dark: {
        primary: "rgb(103, 142, 151)",
      },
    },
  }
});
